<template>
    <div class="sharecomponents">
        <div class="model" @click="close" v-show="show"></div>
        <div class="comp-content" :class="{ 'share-close': show }">
            <div class="area-limit" v-if="areaLimit">商品部分地区不支持发货</div>
            <AddComponents @result="getAddress" v-model="currentAddres" />
        </div>
    </div>
</template>
<script>
import Toast from '@/foundation/toast';

import AddComponents from '@/foundation/address';
export default {
    name: 'sharecomponents',
    components: {
        AddComponents
    },
    props: ['copyUrl', 'show', 'areaLimit'],
    data() {
        return {
            currentAddres: ''
            // copyUrl: window.location.href
        };
    },
    methods: {
        getAddress(value) {
            this.$emit('addressChange', value);
        },
        close() {
            this.$emit('close');
        },
        onSuccess() {
            Toast({ position: 'middle', message: '复制成功' });
        },
        onError() {
            Toast({ position: 'middle', message: '复制失败' });
        }
    }
};
</script>
<style lang="less" scoped>
.sharecomponents {
    .model {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        z-index: 100;
    }

    .comp-content {
        position: fixed;
        left: 50%;
        // border-radius: 14px 14px 0 0;
        transform: translateX(-50%);
        width: 100%;
        bottom: -100%;
        height: 60%;
        transition: all 0.5s;
        background: #fff;
        z-index: 600;
        // padding: 16px 12px;
        .area-limit {
            width: 100%;
            height: 42px;
            background-color: #fbf0dd;
            color: #c99459;
            font-size: 14px;
            font-family: fzlt;
            text-align: center;
            line-height: 42px;
        }
    }
    .share-close {
        bottom: 0;
    }
}
</style>
